import { GetTipiDomandaTipoPubblicazione } from '@framework/api-client';
import { PermissionType, usePermissions } from '@framework/auth';
import {
  CheckboxInput,
  FormItem,
  SelectInput,
  TextInput,
} from '@framework/form';
import { useTranslation } from '@framework/i18n';
import { theme } from '#theme';
import { InquiryAreaSelectInput } from './InquiryAreaSelectInput';
import { InquiryCategorySelectInput } from './InquiryCategorySelectInput';
import { InquiryFilterFormFieldsLogic } from './InquiryFilterFormFieldsLogic';
import { InquiryRecipientTypeSelectInput } from './InquiryRecipientTypeSelectInput';
import { InquiryStateSelectInput } from './InquiryStateSelectInput';

export interface IInquiryFilterFormFieldsProps {
  hideCategorySelect?: boolean;
  /**
   * Indica se il filtro "Destinatari" deve essere bloccato su un valore specifico,
   * derivante dalla Persona Giuridica per cui si sta operando.
   */
  isRecipientTypeLocked?: boolean;
}

/**
 * Campi del Form per la ricerca di domande FrontOffice.
 */
export function InquiryFilterFormFields(props: IInquiryFilterFormFieldsProps) {
  // const showSearchPerScope = process.env.SEARCH_PER_SCOPE;
  const { hideCategorySelect, isRecipientTypeLocked } = props;
  const permissions = usePermissions();
  const { t } = useTranslation();

  return (
    <>
      <FormItem name="titolo" label={t('inquiry.titolo', 'Titolo')}>
        <TextInput name="titolo" placeholder={t('inquiry.titolo', 'Titolo')} />
      </FormItem>
      <FormItem
        name="tipoUtenteDestinatario"
        label={t('inquiry.destinatari', 'Destinatari')}
        tooltip={
          isRecipientTypeLocked
            ? t(
                'inquiry.destinatari-bloccato-persona-giuridica',
                'Filtro impostato automaticamente in base alla Persona Giuridica per cui stai operando.',
              )
            : undefined
        }
      >
        <InquiryRecipientTypeSelectInput
          allowClear={!isRecipientTypeLocked}
          disabled={isRecipientTypeLocked}
          mode="multiple"
          name="tipoUtenteDestinatario"
          placeholder={t('inquiry.destinatari', 'Destinatari')}
        />
      </FormItem>
      {/* {showSearchPerScope && (
        <FormItem name="ambito" label="Ambito">
          <InquiryScopeTreeSelectInput name="ambito" placeholder="Ambito" />
        </FormItem>
      )} */}
      {!hideCategorySelect && (
        <FormItem name="categorie" label={t('inquiry.categorie', 'Categorie')}>
          <InquiryCategorySelectInput
            allowClear
            mode="multiple"
            name="categorie"
            placeholder={t('inquiry.categorie', 'Categorie')}
          />
        </FormItem>
      )}
      {InquiryFilterFormFieldsLogic.showStateSelectFilter() ? (
        <FormItem
          name="stato"
          label={t('inquiry.stato', 'Stato')}
          layout={{ removeLabelSpace: true }}
        >
          <InquiryStateSelectInput
            placeholder={t('inquiry.stato', 'Stato')}
            name={'stato'}
          />
        </FormItem>
      ) : (
        <FormItem
          name="soloAttive"
          label={null}
          layout={{ removeLabelSpace: true }}
        >
          <CheckboxInput name="soloAttive">
            {t('inquiry.solo-attive', 'Solo Attive')}
          </CheckboxInput>
        </FormItem>
      )}

      {theme.showAreaInquiryFilter && (
        <FormItem
          name="codiceAOO"
          label={t('inquiry.area-filter', 'Amministrazione')}
          layout={{ removeLabelSpace: true }}
        >
          <InquiryAreaSelectInput name="codiceAOO" />
        </FormItem>
      )}

      {permissions.has(PermissionType.TestinAccess) && (
        <FormItem
          name="tipoPubblicazione"
          label={t('inquiry.tipo-pubblicazione-filtro', 'Pubblicazione')}
        >
          <SelectInput
            name="tipoPubblicazione"
            options={[
              {
                label: t('inquiry.in-collaudo', 'In Collaudo'),
                value: GetTipiDomandaTipoPubblicazione.IN_COLLAUDO,
              },
              {
                label: t('inquiry.pubblicata', 'Pubblicata'),
                value: GetTipiDomandaTipoPubblicazione.PUBBLICATA,
              },
            ]}
          />
        </FormItem>
      )}
    </>
  );
}
